import styled from "styled-components";

export const Container = styled.div``;

export const FieldGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(4, minmax(0, 1fr));
	gap: 1rem;
	align-items: start;

	@media (max-width: ${({ theme }) => theme.breakpoints.desktopSmall}) {
		grid-template-columns: repeat(2, minmax(0, 1fr));
	}

	@media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
		grid-template-columns: minmax(0, 1fr);
	}
`;

export const WideField = styled.div`
	grid-column: span 2;

	@media (max-width: ${({ theme }) => theme.breakpoints.desktopSmall}) {
		grid-column: auto;
	}
`;

export const AreaButton = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
	margin: 1rem 0;
	gap: 1rem;

	> button {
		max-width: 200px;
	}
`;
